import React from 'react';

export default function DataStatusBanner({ loading, error, empty, emptyMessage = 'Nothing to show right now.' }) {
  if (loading) {
    return (
      <div className="data-status-banner data-status-banner--loading" role="status">
        Loading…
      </div>
    );
  }

  if (error) {
    return (
      <div className="data-status-banner data-status-banner--error" role="alert">
        Unable to load content. Please refresh or try again shortly.
      </div>
    );
  }

  if (empty) {
    return (
      <div className="data-status-banner data-status-banner--empty" role="status">
        {emptyMessage}
      </div>
    );
  }

  return null;
}
